module.exports = __webpack_public_path__ + "img/single@2x.1c03ef5c.png";